import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { Button } from './ui/button';

/**
 * Bottom-right disclaimer: Google Analytics uses cookies. We only enable it
 * if the user accepts; we do not use cookies for advertising.
 */
export function CookieConsentBanner() {
  const { consent, setConsent } = useCookieConsent();

  if (consent !== null) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[9999] max-w-md rounded-2xl border border-gray-200 bg-white p-5 shadow-xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <p id="cookie-consent-title" className="text-sm font-medium text-[#211F1F] mb-1">Cookie preference</p>
      <p id="cookie-consent-description" className="text-sm text-gray-600 mb-4">
        We use cookies to understand how our website is used and to improve its performance.
        By selecting &apos;Accept&apos;, you consent to the use of analytics cookies. You may decline or withdraw consent at any time.
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <Button
          size="sm"
          className="bg-[#C8473A] hover:bg-[#B74F40] text-white"
          onClick={() => setConsent('accepted')}
        >
          Accept
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={() => setConsent('declined')}
        >
          Decline
        </Button>
        <Link
          to="/cookie-policy"
          rel="nofollow"
          className="text-xs text-gray-500 hover:text-[#C8473A] ml-1"
          aria-label="Read cookie policy"
        >
          Cookie Policy
        </Link>
      </div>
    </div>
  );
}
